"use client";
import PropTypes from "prop-types";

import HousingProjectIcon from "assets/svg/housing-project.svg";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Button from "components/common/button";

import styles from "./styles.module.css";

const HousingProjectsCard = ({ criteria }) => {
  const cityName = criteria?.location?.city?.name;
  const getLocationTitle = () => {
    return cityName ? `${cityName} Sıfır Konut Projeleri` : "Sıfır Konut Projeleri";
  };

  const navigateToPage = () => {
    const label = cityName || "genel";
    Ga4WithEventParameters({
      eventName: "click_button",
      eventParameters: { label: `hemen-incele||${label}` },
    });
    window.location.href = cityName
      ? `/satilik-konut/${criteria.location.city.slug}/projeler`
      : `/satilik-konut/projeler`;
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.infoWrapper}>
        <div className={styles.icon}>
          <HousingProjectIcon />
        </div>
        <div className={styles.contentWrapper}>
          <p className={styles.title}>{getLocationTitle()}</p>
          <p className={styles.description}>
            Aradığın bölgede, istediğin özellikteki sıfır konut projelerini incele, hayallerindeki eve kavuş.
          </p>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <Button onClick={navigateToPage} size="M">
          Hemen İncele
        </Button>
      </div>
    </div>
  );
};

HousingProjectsCard.propTypes = {
  criteria: PropTypes.object,
};

export default HousingProjectsCard;
